export enum PUBLIC_PAGES {
  LOGIN = "/login",
}

export enum PRIVATE_PAGES {
  HOME = "/",
  EMPTY = "/",
  MESSAGES = '/messages',
  DASHBOARD = "dashboard",

  INGREDIENTS = "/ingredients",
  UPDATE_INGREDIENT = '/ingredient/:id',
  CREATE_INGREDIENTS = "/ingredient/createion",

  CATEGORIES = "/categories",
  UPDATE_CATEGORY = '/category/:id',
  CREATE_CATEGORIES = "/categories/createion",

  MARKETS = "/markets",
  UPDATE_MARKET = '/markets/:id',
  CREATE_MARKETS = "/markets/createion",

  MARKS = "/map-marks",
  UPDATE_MARK = '/map-marks/:id',
  CREATE_MARKS = "/map-marks/createion",

  BLOGS = '/blogs',
  UPDATE_BLOG = '/blog/:id',
  CREATE_BLOGS = '/blogs/createion',

  PRODUCTS = '/products',
  UPDATE_PRODUCT = '/product/:id',
  CREATE_PRODUCTS = '/products/createion',
  UPDATE_PRODCUTS_ORDERING = '/products/ordering',

  RECIPES = '/recipes',
  UPDATE_RECIPE = '/recipes/:id',
  CREATE_RECIPE = '/recipes/createion',

  TEAMS = '/teams',
  UPDATE_TEAM = '/team/:id',
  CREATE_TEAMS = '/teams/createion',
  UPDATE_TEAMS_ORDERING = '/teams/ordering',

  FAQS = '/faqs',
  UPDATE_FAQ = '/faq/:id',
  CREATE_FAQS = '/faqs/createion',
  UPDATE_FAQ_ORDERING = '/faqs/ordering',

  UPDATE_CONFIG = '/configs'
}
